import StorageService, { FilePurpose } from "api/Storage/StorageService";

export const uploadFile = async (
  file: File,
  project_id: string,
  purpose: FilePurpose,
) => {
  // Request for Signed URL
  const { blob_name, signed_url } = await StorageService.newFileUploadRequest(
    project_id,
    file.name,
    purpose,
  );

  if (signed_url === undefined || blob_name === undefined) {
    return;
  }

  // Upload the file using the signed URL
  await StorageService.uploadFile(signed_url, file);

  // Create file record in backend
  await StorageService.sendFileUploadSuccess(
    project_id,
    blob_name,
    signed_url,
    file.name,
    file.size,
    purpose,
  );
};
